/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MealResponse } from '../model';
// @ts-ignore
import { MenuResponse } from '../model';
/**
 * MenuControllerApi - axios parameter creator
 * @export
 */
export const MenuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDate: async (partnerSlug: string, planSlug: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerSlug' is not null or undefined
            assertParamExists('getByDate', 'partnerSlug', partnerSlug)
            // verify required parameter 'planSlug' is not null or undefined
            assertParamExists('getByDate', 'planSlug', planSlug)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getByDate', 'date', date)
            const localVarPath = `/partners/{partnerSlug}/plans/{planSlug}/menu`
                .replace(`{${"partnerSlug"}}`, encodeURIComponent(String(partnerSlug)))
                .replace(`{${"planSlug"}}`, encodeURIComponent(String(planSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {GetMealOptionsByDateAndMealTypeMealTypeEnum} mealType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealOptionsByDateAndMealType: async (date: string, mealType: GetMealOptionsByDateAndMealTypeMealTypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getMealOptionsByDateAndMealType', 'date', date)
            // verify required parameter 'mealType' is not null or undefined
            assertParamExists('getMealOptionsByDateAndMealType', 'mealType', mealType)
            const localVarPath = `/menus/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (mealType !== undefined) {
                localVarQueryParameter['mealType'] = mealType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MenuControllerApi - functional programming interface
 * @export
 */
export const MenuControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MenuControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByDate(partnerSlug: string, planSlug: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByDate(partnerSlug, planSlug, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {GetMealOptionsByDateAndMealTypeMealTypeEnum} mealType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMealOptionsByDateAndMealType(date: string, mealType: GetMealOptionsByDateAndMealTypeMealTypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MealResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMealOptionsByDateAndMealType(date, mealType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MenuControllerApi - factory interface
 * @export
 */
export const MenuControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MenuControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} partnerSlug 
         * @param {string} planSlug 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDate(partnerSlug: string, planSlug: string, date: string, options?: any): AxiosPromise<MenuResponse> {
            return localVarFp.getByDate(partnerSlug, planSlug, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {GetMealOptionsByDateAndMealTypeMealTypeEnum} mealType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMealOptionsByDateAndMealType(date: string, mealType: GetMealOptionsByDateAndMealTypeMealTypeEnum, options?: any): AxiosPromise<Array<MealResponse>> {
            return localVarFp.getMealOptionsByDateAndMealType(date, mealType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MenuControllerApi - object-oriented interface
 * @export
 * @class MenuControllerApi
 * @extends {BaseAPI}
 */
export class MenuControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} partnerSlug 
     * @param {string} planSlug 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuControllerApi
     */
    public getByDate(partnerSlug: string, planSlug: string, date: string, options?: AxiosRequestConfig) {
        return MenuControllerApiFp(this.configuration).getByDate(partnerSlug, planSlug, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {GetMealOptionsByDateAndMealTypeMealTypeEnum} mealType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuControllerApi
     */
    public getMealOptionsByDateAndMealType(date: string, mealType: GetMealOptionsByDateAndMealTypeMealTypeEnum, options?: AxiosRequestConfig) {
        return MenuControllerApiFp(this.configuration).getMealOptionsByDateAndMealType(date, mealType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMealOptionsByDateAndMealTypeMealTypeEnum = {
    Breakfast: 'BREAKFAST',
    SnackAm: 'SNACK_AM',
    Lunch: 'LUNCH',
    SideDish: 'SIDE_DISH',
    SnackPm: 'SNACK_PM',
    Dinner: 'DINNER',
    Salad: 'SALAD',
    Drink: 'DRINK',
    Appetizer: 'APPETIZER',
    Fruit: 'FRUIT',
    Iftar: 'IFTAR',
    Snack: 'SNACK',
    Suhoor: 'SUHOOR',
    Smoothie: 'SMOOTHIE',
    Soup: 'SOUP'
} as const;
export type GetMealOptionsByDateAndMealTypeMealTypeEnum = typeof GetMealOptionsByDateAndMealTypeMealTypeEnum[keyof typeof GetMealOptionsByDateAndMealTypeMealTypeEnum];
